export const MODEL_TYPES = {
  GENERICS: 'generics',
  GROUPS: 'groups',
  USERS: 'users',
};

export const PROP_MODEL_TYPES = Object.values(MODEL_TYPES);
